import React from 'react';
import { StyleSheet, TouchableOpacity, type TouchableOpacityProps } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../../../Text';
import { NAVBAR_FLOATING_ACTION_SIZE } from '../../../../Navbar.constants';
import { NavbarGlassView } from '../NavbarGlassView/NavbarGlassView';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingAuthButton = (props: Props) => {
  const { children, shadow, ...restProps } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <TouchableOpacity accessibilityRole="link" activeOpacity={0.7} {...restProps}>
      <NavbarGlassView canHover shadow={shadow} style={styles.container}>
        <BodyText
          sizeMatch={['16']}
          maxFontSizeMultiplier={1.2}
          numberOfLines={1}
          bold
          style={styles.label}
        >
          {children}
        </BodyText>
      </NavbarGlassView>
    </TouchableOpacity>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    height: NAVBAR_FLOATING_ACTION_SIZE,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing['2'],
    paddingHorizontal: theme.spacing['8'],
  },
  label: {
    color: theme.colors.KALE,
    marginTop: 3, // for better vertical alignment
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Pick<TouchableOpacityProps, 'children' | 'onPress'> & {
  shadow?: boolean;
};
